import { Component} from '@angular/core';
import { PrivacyBaseComponent } from '@src/base-components/privacy/privacy-base.component';
import { ConfigService } from '@src/services/layout/config.service';

@Component({
    selector: 'app-page-privacy',
    templateUrl: '../../../base-components/privacy/privacy-base.component.html',
    styleUrls: ['../../../base-components/privacy/privacy-base.component.scss']
})
export class PrivacyComponent extends  PrivacyBaseComponent{
    constructor(configService: ConfigService) {
        const params = {
            appName: 'OWA',
            companyName: 'Oris',
            products: 'watches',
            ContactEmail : 'owa@oris.ch'
        };
        const logoUrl = '';
        super(params, logoUrl, configService);
    }
}